export const notificationDrawer = {
  notificationDrawerTitle: "Notifications",
  notificationDrawerDeleteBtn: "Delete",
  notificationDrawerDeletedNotification: "Notification deleted",
  notificationDrawerDeletedFailed: "Notification delete failed",
  notificationMarkReadFailed: "Notification mark as read failed",
  notificationDrawerNotifications: "No notifications",
  notificationDrawerPlay: "Play",
  notificationDrawerPlayGame: "Go to game",
};
